import React from "react";
import {useSelector} from "react-redux";
import {ButtonGroup, Button} from "@mui/material";

import {useAction} from "../../../../../../hooks";

const EventsAction = ({playerId, eventName}) => {
    const {players} = useSelector(state => state.player);
    const player = players.find(player => player.id === playerId);
    const {incrementEvent, decrementEvent} = useAction()
    const {isStart, isFinish, isPause} = useSelector(state => state.match);
    const isGameOff = !isStart || isFinish || isPause || !player.inGame;

    return (
        <div className="match-view-event">
            <div className="match-view-event-count">
                {`${player.events[eventName]}`}
            </div>
            <ButtonGroup variant="contained" sx={{
                '& .MuiButtonGroup-grouped': {
                    minWidth: 'unset',
                    height: 25
                },
            }}>
                <Button
                    size="small"
                    disabled={player.events[eventName] === 0 || isGameOff}
                    color="error"
                    variant="contained"
                    onClick={() => {
                        decrementEvent({id: playerId, eventName})
                    }}
                >
                    -
                </Button>
                <Button
                    disabled={isGameOff}
                    size="small"
                    color="success"
                    variant="contained"
                    onClick={() => {
                        incrementEvent({id: playerId, eventName})
                    }}
                >
                    +
                </Button>
            </ButtonGroup>
        </div>
    )
};

export default EventsAction